import {l} from "types/typescriptdefinisjoner_lederplan";
import {IPromise} from "angular";
import {LokaltDatalager} from "./LokaltDatalager";
import {konverterIso8601DatoStrengTilDate} from "../infrastruktur/Iso8601DatostrengTilDate";
import {Debugger} from 'debug'

const debug: Debugger = require('debug')('LokallagretAutentisertModel');

export class LokallagretAutentisertModel {

    static regNavn = "LokallagretAutentisertModel";

    static forInjisering() {
        return [
            LokaltDatalager.regNavn,
            LokallagretAutentisertModel
        ]
    }

    constructor(private datalager: LokaltDatalager) {
    }

    /** Henter AutentisertOkModel lagret i nettlesers datalager */
    hent(): IPromise<l.AutentisertOkModell> {
        return this.datalager.hent("autentisert")
          .then(autentisert => konverterIso8601DatoStrengTilDate(autentisert));
    }

    oppdaterBrukervalg(brukervalg: l.Brukervalg): IPromise<any> {
        return this.hent()
          .then(autentisert => {
              autentisert.brukervalg = brukervalg;
              return this.lagre(autentisert);
          })
    }

    /** Lagrer angitt AutentisertOkModel i nettlesers datalager */
    lagre(autentisert: l.AutentisertOkModell) {
        return this.datalager.lagre("autentisert", autentisert);
    }

    /** Sletter AutentisertOkModel lagret i nettlesers datalager */
    slett() {
        return this.datalager.slett("autentisert");
    }

}
